import { compose } from "redux";
import classNames from "classnames";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Clear from "@material-ui/icons/Clear";
import { Grid, withStyles, IconButton, Divider } from "@material-ui/core";

import { EMPTY_LIST } from "app/app.constants";
import { GROUP_TYPES } from "features/planner/planner.constants";
import ViewGroupContainer from "features/planner/components/ViewGroup/ViewGroupContainer";
import { getViewGroupIdsForGroupTypeAndColumnFromState } from "features/planner/planner.selectors";
import DraggableViewGroupDropTarget from "features/planner/components/DraggableViewGroupDropTarget";

class ViewGroupColumn extends PureComponent {
  deleteViewGroupColumn = () => {
    const { type, column, deleteViewGroupColumn } = this.props;

    deleteViewGroupColumn(type, column);
  };

  render() {
    const {
      type,
      column,
      viewId,
      classes,
      isEditMode,
      viewGroupIds,
      saveViewGroupOrder,
    } = this.props;

    return (
      <DraggableViewGroupDropTarget
        type={type}
        column={column}
        viewId={viewId}
        size={viewGroupIds.size}
        onDrop={saveViewGroupOrder}
      >
        <Grid
          xs
          item
          container
          wrap="nowrap"
          direction="column"
          className={classNames(classes.columnRoot, classes[type], {
            [classes.isEditMode]: isEditMode,
          })}
        >
          {isEditMode && (
            <>
              <Grid
                container
                justifyContent="flex-end"
                className={classes.columnTopContent}
              >
                <IconButton
                  size="small"
                  variant="contained"
                  title="Remove column"
                  onClick={this.deleteViewGroupColumn}
                >
                  <Clear fontSize="small" />
                </IconButton>
              </Grid>
              <Grid container component={Divider} />
            </>
          )}
          {viewGroupIds.map((viewGroupId, viewColumnOrder) => (
            <ViewGroupContainer
              type={type}
              viewId={viewId}
              key={viewGroupId}
              viewColumn={column}
              isEditMode={isEditMode}
              viewGroupId={viewGroupId}
              viewColumnOrder={viewColumnOrder}
            />
          ))}
        </Grid>
      </DraggableViewGroupDropTarget>
    );
  }
}

const styles = theme => ({
  root: {
    display: "flex",
    overflow: "hidden",
    flexDirection: "column",
    paddingTop: theme.spacing(1),
  },
  content: {
    overflow: "auto",
  },
  columnRoot: {
    padding: `0 ${theme.spacing(1)}px`,
  },
  [GROUP_TYPES.LOCATION_GROUP]: {
    width: theme.altus.viewGroup.width * 2,
    maxWidth: theme.altus.viewGroup.width * 2,
    minWidth: theme.altus.viewGroup.width * 2 - 10, // adjust for scrollbar
  },
  [GROUP_TYPES.PLANNING_GROUP]: {
    width: theme.altus.viewGroup.width,
    maxWidth: theme.altus.viewGroup.width,
    minWidth: theme.altus.viewGroup.width - 10, // adjust for scrollbar
  },
  isEditMode: {
    backgroundClip: "content-box",
    background: theme.palette.grey[100],
  },
  columnTopContent: {
    padding: theme.spacing(0.5),
  },
  isDragging: {
    opacity: 0.2,
  },
});

ViewGroupColumn.defaultProps = {
  viewGroupIds: EMPTY_LIST,
};

export default compose(
  connect((state, { type, column }) => ({
    viewGroupIds: getViewGroupIdsForGroupTypeAndColumnFromState(
      state,
      type,
      column,
    ),
  })),
  withStyles(styles),
)(ViewGroupColumn);
